import React from "react";

import { TaxTitle } from "./styles";

const TaxHeader = () => {
  return <TaxTitle data-test='contributionTaxReceipt'>Recent tax receipts</TaxTitle>;
};

export default TaxHeader;
